import React, { useEffect, useState } from "react";
import "./AdvertisementSlider.css";

export default function AdvertisementSlider() {
  const [ads, setAds] = useState([]);
  const [current, setCurrent] = useState(0);
  const [mainAds, setMainAds] = useState([]);

const [sideAds, setSideAds] = useState([]);

const [mainCurrent, setMainCurrent] = useState(0);
const [sideCurrent, setSideCurrent] = useState(0);

  useEffect(() => {
    loadAds();
  }, []);

const loadAds = async () => {
  try {
    const res = await fetch("/api/advertisements");
    const data = await res.json();

    setMainAds(
      data.ads.filter(ad => ad.adType === "main")
    );

    setSideAds(
      data.ads.filter(ad => ad.adType === "side")
    );
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  if (mainAds.length <= 1) return;

  const timer = setInterval(() => {
    setMainCurrent(prev => (prev + 1) % mainAds.length);
  }, 8000);

  return () => clearInterval(timer);
}, [mainAds]);
useEffect(() => {
  if (sideAds.length <= 3) return;

  const timer = setInterval(() => {
    setSideCurrent(prev => (prev + 3) % sideAds.length);
  }, 8000);

  return () => clearInterval(timer);
}, [sideAds]);const visibleSideAds = [];

for (let i = 0; i < 3; i++) {
  if (sideAds.length) {
    visibleSideAds.push(sideAds[(sideCurrent + i) % sideAds.length]);
  }
}

  return (
  <section className="advertisement-slider py-12">

  {/* Left Main Banner */}
  <div className="big-ad">
    {mainAds.length > 0 && (
      <>
        <img
          src={mainAds[mainCurrent].imageUrl}
          alt={mainAds[mainCurrent].title}
        />

        <div className="ad-content">
          <h2>{mainAds[mainCurrent].title}</h2>
          <p>{mainAds[mainCurrent].subtitle}</p>

          {mainAds[mainCurrent].buttonText && (
            <a
              href={mainAds[mainCurrent].buttonLink}
              target="_blank"
              rel="noreferrer"
              className="ad-btn"
            >
              {mainAds[mainCurrent].buttonText}
            </a>
          )}
        </div>
      </>
    )}
  </div>

  {/* Right Side Ads */}
  <div className="right-ads">
    {visibleSideAds.map(ad => (
      <div className="small-ad" key={ad.id}>
        <img src={ad.imageUrl} alt={ad.title} />
      </div>
    ))}
  </div>

</section>
  );
}